type LinkedInTrack = {
    (action: 'track', data: { conversion_id: string }): void;
    q: Array<['track', { conversion_id: string }]>;
};

const SUBDOMAIN = 'px';

let activePartnerId: string | null = null;

export const initLinkedinPixel = (pixelId: string, disabled = false) => {
    if (typeof window === 'undefined' || disabled) return;

    activePartnerId = pixelId;
    window._linkedin_partner_id = pixelId;
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(pixelId);

    if (!window.lintrk) {
        const queuedTrack: LinkedInTrack = function (a, b) {
            queuedTrack.q.push([a, b]);
        };
        queuedTrack.q = [];
        window.lintrk = queuedTrack;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';

    const s = document.getElementsByTagName('script')[0];
    s.parentNode?.insertBefore(script, s);

    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.alt = '';
    img.src = `https://${SUBDOMAIN}.ads.linkedin.com/collect/?pid=${pixelId}&fmt=gif`;

    noscript.appendChild(img);
    document.body.appendChild(noscript);
};

export const trackPageView = () => {
    if (typeof window === 'undefined' || !activePartnerId) return;

    if (window.lintrk) {
        window.lintrk('track', { conversion_id: 'pageview' });
        return;
    }

    trackWithImage('pageview');
};

export const track = (conversionId: string) => {
    if (typeof window === 'undefined' || !activePartnerId) return;

    if (window.lintrk) {
        window.lintrk('track', { conversion_id: conversionId });
        return;
    }

    trackWithImage(conversionId);
};

const trackWithImage = (conversionId: string) => {
    if (typeof window === 'undefined' || !activePartnerId) return;

    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.alt = '';
    img.src = `https://${SUBDOMAIN}.ads.linkedin.com/collect/?pid=${activePartnerId}&conversionId=${conversionId}&fmt=gif`;

    document.body.appendChild(img);
};

// Declaración de tipos para TypeScript
declare global {
    interface Window {
        _linkedin_partner_id: string;
        _linkedin_data_partner_ids: string[];
        lintrk?: LinkedInTrack;
    }
}
